import React from 'react';
import { PieChart, Pie, Cell, Tooltip, ResponsiveContainer } from 'recharts';
import { Box, Typography } from '@mui/material';

const COLORS = [
    '#2196F3', '#4CAF50', '#FF9800', '#9C27B0', '#E91E63',
    '#00BCD4', '#FF5722', '#607D8B', '#795548', '#3F51B5',
];

const formatCurrency = (v) =>
    new Intl.NumberFormat('fr-BE', { style: 'currency', currency: 'EUR', maximumFractionDigits: 0 }).format(v || 0);

const CustomerBreakdown = ({ customers }) => {
    if (!customers?.by_customer || customers.by_customer.length === 0) return null;

    const data = customers.by_customer.slice(0, 10);

    return (
        <Box sx={{ mb: 4 }}>
            <Typography variant="h6" sx={{ fontWeight: 600, mb: 2 }}>
                CA par client
            </Typography>
            <Box display="flex" flexWrap="wrap" gap={2} alignItems="center">
                <ResponsiveContainer width="45%" height={220}>
                    <PieChart>
                        <Pie data={data} dataKey="revenue_untaxed" nameKey="customer_name" innerRadius={55} outerRadius={95} paddingAngle={2}>
                            {data.map((entry, index) => (
                                <Cell key={entry.customer_name} fill={COLORS[index % COLORS.length]} />
                            ))}
                        </Pie>
                        <Tooltip formatter={(v) => formatCurrency(v)} />
                    </PieChart>
                </ResponsiveContainer>
                <Box sx={{ flex: 1, minWidth: 200 }}>
                    {data.map((d, index) => (
                        <Box key={d.customer_name} display="flex" justifyContent="space-between" alignItems="center" sx={{ mb: 0.75 }}>
                            <Box display="flex" alignItems="center" gap={1}>
                                <Box sx={{ width: 12, height: 12, borderRadius: '2px', flexShrink: 0, backgroundColor: COLORS[index % COLORS.length] }} />
                                <Typography variant="body2" noWrap sx={{ maxWidth: 160 }}>{d.customer_name}</Typography>
                                <Typography variant="caption" color="text.secondary">({d.invoice_count})</Typography>
                            </Box>
                            <Box textAlign="right">
                                <Typography variant="body2" sx={{ fontWeight: 600 }}>
                                    {formatCurrency(d.revenue_untaxed)}
                                </Typography>
                                <Typography variant="caption" color="text.secondary">
                                    {d.share_pct}%
                                </Typography>
                            </Box>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
};

export default CustomerBreakdown;
